module.exports = __webpack_public_path__ + "static/img/preview-bg.1b09c99b.png";